import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(public)/sale/layout.tsx");
